<!-- BANNER -->
<div class="promo-gamer-container-img">
  <img [src]="imageSrc" alt="Banner Promo Gamer" style="width: 90%; height: auto;" />
</div>

<!-- CONTAINER INFO --->
<div class="promo-container-info">
  <h2>¡Sumate a la Promo Gamer en estaciones Shell adheridas!</h2>

  <!-- FILTERS -->
  <div class="container-filters">

    <app-dropdown-search [options]="provinceList" placeholderProp="Seleccioná una provincia"
      (optionSelected)="onProvinceSelected($event)"></app-dropdown-search>

    <app-dropdown-search [options]="cityList" placeholderProp="Seleccioná una ciudad" [disabled]="!selectedProvince"
      (optionSelected)="onCitySelected($event)"></app-dropdown-search>

  </div>


  <!-- CARDS -->
  <div class="container-cards">

    <ng-container *ngIf="isLoading; else showCards">
      <div class="spinner"></div>
    </ng-container>
  
    <ng-template #showCards>
      <ng-container *ngIf="cards.length > 0; else noCards">
        <div class="card-promo" *ngFor="let card of cards">
          <div class="card-promo-left">
            <img src="../../../assets/images/Logo-shell-promo-gamer.svg" alt="logo shell" />
          </div>
  
          <div class="card-promo-right">
            <div class="card-promo-right-title">
              <h3>{{card.city | toTitleCase}}</h3>
              <p>{{card.address | toTitleCase}}</p>
            </div>
  
            <div class="card-promo-right-actions" [ngClass]="{'card-promo-right-actions-without-distance': card.distance === null}">
              <h3 *ngIf="card.distance !== null">{{card.distance | FormatNumberForKm}} km</h3>
              <button (click)="openGoogleMapsDirections(card.latitude, card.longitude)">Cómo llegar</button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  
  </div>

  <ng-template #noCards>
    <div  class="no-cards">
      <h2>No encontramos estaciones adheridas en esta zona.</h2>
      <p>Selecciona otra localidad o provincia para ver Tiendas Shell Select con la Promo Gamer</p>
    </div>
  </ng-template>
  